import { render, staticRenderFns } from "./ShopView05.vue?vue&type=template&id=28e77730&scoped=true&"
import script from "./ShopView05.vue?vue&type=script&lang=js&"
export * from "./ShopView05.vue?vue&type=script&lang=js&"
import style0 from "./ShopView05.vue?vue&type=style&index=0&id=28e77730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e77730",
  null
  
)

export default component.exports